import { render, staticRenderFns } from "./AddApplicationQuestion.vue?vue&type=template&id=590166f3&scoped=true"
import script from "./AddApplicationQuestion.vue?vue&type=script&lang=js"
export * from "./AddApplicationQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590166f3",
  null
  
)

export default component.exports